import Default from '@pages/config'

export default {
  path: 'config',
  name: 'config',
  components: {
    default: Default,
  },
}